<template lang="pug">
.briq-expansion-panel(:class="{expanded}")
  button.briq-expansion-panel-header.mb-XS(
    type="button"
    :style="keepPanelExpanded ? `cursor: auto;` : ``"
    @click="!keepPanelExpanded ? expanded = !expanded : () => {}"
    )
    slot(name="header")
    .briq-expansion-panel-header-icon(v-if="!keepPanelExpanded" :class="{ rotated: expanded }")
      BriqIcon(name="icon-input-arrow-down-icon")
  transition(name="slide")
    .briq-expansion-panel-content(v-show="expanded")
      slot(name="content")
</template>

<script>
export default {
  name: 'BriqExpansionPanel',
  props: {
    value: Boolean,
    keepPanelExpanded: Boolean,
  },
  data() {
    return { innerValue: this.value || false }
  },
  computed: {
    expanded: {
      get() {
        return this.innerValue
      },
      set(v) {
        this.$emit('input', v)
        this.innerValue = v
      },
    },
  },
  watch: {
    value(v) {
      this.innerValue = v
    },
  },
}
</script>

<style scoped lang="stylus">
.briq-expansion-panel
  background white
  box-shadow 0 3px 1px -2px rgba(0, 0, 0, 20%), 0 2px 2px 0 rgba(0, 0, 0, 14%), 0 1px 5px 0 rgba(0, 0, 0, 12%)

.briq-expansion-panel-header
  display flex
  align-items center
  justify-content space-between
  text-align left
  width 100%
  cursor pointer
  transition background-color 0.2s ease
  padding 16px 24px
  margin 0

  &:hover
    background-color whitesmoke

.briq-expansion-panel-header-icon
  transition transform ease-out 0.3s

  &.rotated
    transform rotate(-180deg)

  .content
    background-color #EFF3F7
</style>
